import React, {ReactElement} from "react";
import "./StepperContent.css"
import {Blockquote} from "@mantine/core";

export type StepperContentProps = {
    title?: string | boolean,
    description: string | boolean
    children: ReactElement
}

export function StepperContent(props: StepperContentProps) {
    return (
        <div className={"stepper-content"}>
            {props.title && (<div className={"stepper-left centered"}>
                <div className={""}>
                    <h2 className={"stepper-content-title"}>{props.title}</h2>
                </div>
                <div>
                    <Blockquote cite="- Sellina ">
                        {props.description}
                    </Blockquote>
                </div>
            </div>)}
            <div className={"stepper-right  full-width-height"}>
                {props.children}
            </div>

        </div>
    );
}
